import React, { useContext, useState } from 'react'
import {
  Box,
  Button,
  useTheme
} from '@mui/material'
import LinkIcon from '@mui/icons-material/Link'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import ErrorReportDialog from './ErrorReportDialog'
import { AppContext } from '../contexts/AppProvider'
import { useCopyToClipboard } from 'usehooks-ts'
import { toast } from 'react-toastify'
import { urlParamQuantityToConvert } from '../constants'

const SingleTabUsefulButtons: React.FC = () => {
  const theme = useTheme()
  const [openErrorReportDialog, toggleOpenErrorReportDialog] = useState(false)
  const { appState } = useContext(AppContext)
  const { currentMeasure } = appState
  const { isConversionValid, fromNumber } = appState.tabs[currentMeasure.codeName]
  const [, copy] = useCopyToClipboard()

  const handleShareConversionClick = async (): Promise<void> => {
    try {
      const url = new URL(window.location.href)
      url.search = '' // Clear existing query parameters
      const encodedNumber = encodeURIComponent(fromNumber)
      url.searchParams.set(urlParamQuantityToConvert, encodedNumber)

      const isCopiedSuccessfully = await copy(url.toString())

      if (isCopiedSuccessfully) {
        toast.info(
          <>
            Copied url to clipboard
            <br />
            {url.toString()}
            <br />
          </>
          , { autoClose: 3100 })
      } else {
        toast.error('Failed to copy URL to clipboard.')
      }
    } catch (error) {
      console.error('Error sharing conversion:', error)
      toast.error('Something went wrong while creating share link.')
    }
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      width: '100%',
      padding: { xs: '0 4px', sm: '0 20px', md: '0 50px', lg: '0 105px' },
      marginTop: 'auto',
      marginBottom: { xs: '10px', sm: '15px' },
      alignItems: 'center',
      justifyContent: 'space-evenly'
    }}>
      {<Button
          disabled={!isConversionValid}
          size="large"
          variant="contained"
          onClick={handleShareConversionClick}
          sx={{
            background: theme.palette.custom.beautifulGradient,
            marginBottom: { xs: '10px', sm: '0' }
          }}
          endIcon={<LinkIcon />}
        >
          Copy Link
        </Button>}
      <Button
        disabled={false}
        size="large"
        variant="contained"
        // onClick={}
        sx={{
          background: theme.palette.custom.redGradient,
          marginBottom: { xs: '10px', sm: '0' }
        }}
        endIcon={<ErrorOutlineIcon />}
        onClick={() => toggleOpenErrorReportDialog(true)}
      >
        Report error
      </Button>
      <ErrorReportDialog open={openErrorReportDialog} setOpen={toggleOpenErrorReportDialog} />
    </Box>
  )
}


export default SingleTabUsefulButtons
